import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { createPortal } from 'react-dom';

const LegalModal = ({ open, type, onClose }) => {
  useEffect(() => {
    // Track open modals to avoid clobbering body overflow when multiple modals are used
    if (typeof window !== 'undefined') {
      window.__modalCount = (window.__modalCount || 0) + (open ? 1 : 0);
      if (open) {
        document.body.style.overflow = 'hidden';
      }
    }
    return () => {
      if (typeof window !== 'undefined') {
        window.__modalCount = Math.max(0, (window.__modalCount || 1) - (open ? 1 : 0));
        if (!window.__modalCount) {
          document.body.style.overflow = '';
        }
      }
    };
  }, [open]);

  if (!open) return null;

  const privacyBody = (
    <div>
      <p>This Privacy Notice explains how Radha IT collects, uses, discloses and protects personal information in Ontario, Canada.</p>
      <h4>Organization</h4>
      <p>Radha IT — info@radhait.ca</p>

      <h4>Purpose of Collection</h4>
      <p>We collect personal information to respond to enquiries, provide services, manage contracts, and comply with legal obligations.</p>

      <h4>Legal Authority & Consent</h4>
      <p>We rely on consent and contractual necessity to collect and use personal information. By contacting us or using our services you consent to this use.</p>

      <h4>Use & Disclosure</h4>
      <p>Information may be shared with service providers and as required by law. We do not sell personal information.</p>

      <h4>Retention</h4>
      <p>We retain information only as long as necessary for the purposes described and as required by applicable laws.</p>

      <h4>Access & Correction</h4>
      <p>Individuals may request access to their personal information or request corrections by emailing info@radhait.ca.</p>

      <h4>Complaints</h4>
      <p>If you have privacy concerns, contact us. You may also contact the Information and Privacy Commissioner of Ontario.</p>

      <p className="muted small mt-4">Last updated: April 2026</p>
    </div>
  );

  const termsBody = (
    <div>
      <p>These Terms of Service govern the use of Radha IT's services. By engaging our services you agree to these terms.</p>

      <h4>Services</h4>
      <p>We provide IT, cloud, AI, security, networking and AV services as described in proposals and agreements.</p>

      <h4>Payment</h4>
      <p>Fees are due as specified in quotes or contracts. Unpaid amounts may incur interest and collection costs.</p>

      <h4>Confidentiality</h4>
      <p>Both parties will keep confidential information secure and only use it as permitted in agreements.</p>

      <h4>Limitation of Liability</h4>
      <p>To the extent permitted by law, Radha IT's liability is limited to the amount paid for the services and we are not liable for indirect or consequential damages.</p>

      <h4>Governing Law</h4>
      <p>These terms are governed by the laws of the Province of Ontario, Canada.</p>

      <p className="muted small mt-4">Last updated: April 2026</p>
    </div>
  );

  const title = type === 'terms' ? 'Terms of Service' : 'Privacy Notice';
  const body = type === 'terms' ? termsBody : privacyBody;

  const modal = (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[99999] p-4"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="legal-title"
    >
      <motion.div
        className="bg-white dark:bg-gray-900 rounded-2xl p-8 max-w-3xl w-full text-left shadow-2xl modal-content"
        style={{ maxHeight: 'calc(100vh - 4rem)' }}
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
      >
        <div className="flex items-start justify-between">
          <h3 id="legal-title" className="text-xl font-bold text-gray-900 dark:text-gray-100">{title}</h3>
          <button onClick={onClose} className="modal-close-btn" aria-label="Close legal dialog">×</button>
        </div>
        <div className="mt-4 text-gray-700 dark:text-gray-200">
          {body}
        </div>
        <div className="mt-6 text-right">
          <button
            onClick={onClose}
            className="modal-btn"
          >
            Close
          </button>
        </div>
      </motion.div>
    </motion.div>
  );

  return typeof document !== 'undefined' ? createPortal(modal, document.body) : null;
};

export default LegalModal;
